// Status: active
//
// `broadcast.steps-reconcile-requested.v1` — internal marketing event emitted
// by the 15-minute AWS reconciliation cron after it refreshes a CharityStack
// broadcast mirror row from PocketFlows. The marketing Inngest worker consumes
// one event per broadcast and durably reconstructs complete per-step and
// distinct-per-contact metrics from every execution in the planned snapshot.
//
// Producer: marketing reconciliation cron.
// Consumer: marketing `reconcile-broadcast-steps` workflow.

import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const broadcastStepsReconcileRequestedV1Schema = eventEnvelopeSchema.extend({
  broadcastId: z.string().uuid(),
  // Epoch milliseconds from the originating EventBridge scheduled event.
  // Retries keep the same generation; a later sweep has a larger generation.
  generation: z.number().int().nonnegative(),
});

export type BroadcastStepsReconcileRequestedV1 = z.infer<
  typeof broadcastStepsReconcileRequestedV1Schema
>;

export const BROADCAST_STEPS_RECONCILE_REQUESTED_V1_DETAIL_TYPE =
  'broadcast.steps-reconcile-requested.v1' as const;
